<div class="d-flex justify-content-between w-100 nav-container small-screen">
  <div class="d-flex align-items-center justify-content-between nav-container w-100">
    <div class="d-flex align-items-center nav-items">
      @if (showNav()) {
        @if (selectedPortfolio()) {
          <div
            class="custom-border cursor-pointer nav-item text-primary d-flex justify-content-between mr-2"
            [ngClass]="{ 'selected-item': isLevelSelected('portfolio') }"
            (click)="navigateToPortfolioLevel()"
            (keydown)="navigateToPortfolioLevel()"
            role="button"
            tabindex="0"
          >
            <div class="d-flex align-items-center nav-item-name">
              <div class="pl-0 pr-1 d-flex align-items-center">
                <img [src]="'icon-portfolio' | iconsPipe: isLevelSelected('portfolio') | async" alt="icon" />
              </div>
              <div class="d-flex nav-name flex-column">
                <div
                  class="font-weight-bold m-0 labels"
                  #portfolioNameLabel
                  [matTooltip]="selectedPortfolio()?.name || ''"
                  [matTooltipDisabled]="!isTextOverflowing(portfolioNameLabel)"
                >
                  {{ selectedPortfolio()?.name }}
                </div>
                <div class="font-size-small">Portfolio ({{ portfolioOptions()?.length }})</div>
              </div>
            </div>
            <div class="d-flex align-items-center nav-item-actions">
              <div
                class="ml-2 border rounded"
                [ngClass]="{
                  'selected-item action-button': shown.portfolio,
                  'button-enabled': portfolioOptions()?.length > 1,
                  'cursor-default': portfolioOptions()?.length <= 1,
                }"
              >
                <lib-select
                  class="navigation"
                  [options]="portfolioOptions()"
                  [label]="selectedPortfolio()?.name"
                  [classes]="'font-size-normal text-primary h-100 mr-2'"
                  [itemClasses]="'text-primary font-size-very-small item'"
                  [disabled]="portfolioOptions()?.length <= 1"
                  [notBold]="true"
                  [showCaret]="true"
                  [fullWidth]="true"
                  [placement]="'bottom-right'"
                  [container]="''"
                  [doNotTranslate]="true"
                  [enableSearch]="true"
                  (selectedChanged)="selectPortfolio($event)"
                  (click)="$event.stopPropagation()"
                  [matTooltip]="portfolioOptions()?.length <= 1 ? 'Only 1 portfolio available' : null"
                />
              </div>
            </div>
          </div>
        }
        @if (countryList()?.length && navigationService.moduleIdSig() !== 'reports') {
          <div
            class="custom-border cursor-pointer nav-item text-primary d-flex justify-content-between mr-2"
            [ngClass]="{ 'selected-item': isLevelSelected('country') || isLevelSelected('region') }"
            (click)="navigateToCountryLevel()"
            (keydown)="navigateToCountryLevel()"
            role="button"
            tabindex="0"
          >
            <div class="d-flex align-items-center nav-item-name">
              <div class="pl-0 pr-1 d-flex align-items-center">
                <img [src]="'icon-country' | iconsPipe: isLevelSelected('country') | async" alt="icon" />
              </div>
              <div class="d-flex nav-name flex-column">
                <div
                  class="font-weight-bold m-0 labels"
                  #countryNameLabel
                  [matTooltip]="selectedCountry()?.name || ''"
                  [matTooltipDisabled]="!isTextOverflowing(countryNameLabel)"
                >
                  {{ selectedCountry()?.name }} 
                  @if (selectedRegion()?.name) {
                    ({{ selectedRegion()?.name }})
                  }
                </div>
                <div class="font-size-small">Country ({{ countryList()?.length }})</div>
              </div>
            </div>

            <div class="d-flex align-items-center nav-item-actions">
              <div
                class="ml-2 border rounded"
                [ngClass]="{
                  'button-enabled': hasMultipleCountryOptions(),
                  'cursor-default': !hasMultipleCountryOptions(),
                }"
                [matTooltip]="!hasMultipleCountryOptions() ? 'Only 1 country available' : null"
                [class.country-trigger-disabled]="!hasMultipleCountryOptions()"
                [matMenuTriggerFor]="hasMultipleCountryOptions() ? countryMenu : null"
                (click)="$event.stopPropagation()"
              >
                <!-- Mat menu trigger button -->
                <div
                  class="d-inline-flex align-items-center font-size-normal text-primary h-100 trigger-country"
                >
                  <i class="fas fa-chevron-down text-primary font-size-small"></i>
                </div>

                <!-- Root country menu -->
                <mat-menu #countryMenu="matMenu" class="lib-select-menu" yPosition="below" xPosition="before">
                  <!-- Search -->
                  <div class="mx-2 my-2" (click)="$event.stopPropagation()">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text"><i class="fas fa-search"></i></span>
                      </div>
                      <input
                        type="text"
                        class="form-control search-input"
                        placeholder="Search..."
                        [ngModel]="countrySearch()"
                        (ngModelChange)="countrySearch.set($event)"
                        (click)="$event.stopPropagation()"
                      />
                    </div>
                  </div>

                  @for (country of filteredCountriesOptions(); track country._id) {
                    <!-- Country WITH regions -->
                    @if (country.regions?.length > 0) {
                      <button
                        mat-menu-item
                        [matMenuTriggerFor]="regionMenu"
                        class="lib-select-item"
                      >
                        <span class="ellipsis p-2 px-3 d-block opacity-dark-9 text-primary font-size-small item d-flex justify-content-between align-items-center" [class.font-weight-bold]="selectedCountry()?._id === country._id">
                          {{ country.name }}
                          <i class="fas fa-chevron-right font-size-small"></i>
                        </span>
                      </button>

                      <mat-menu #regionMenu="matMenu" class="lib-select-menu">
                        @for (region of country.regions; track region._id) {
                          <button
                            mat-menu-item
                            class="lib-select-item"
                            (click)="selectRegion(country, region)"
                          >
                            <span class="ellipsis p-2 px-3 d-block opacity-dark-9 text-primary font-size-small item" [class.font-weight-bold]="selectedRegion()?._id === region._id">
                              {{ region.name }}
                            </span>
                          </button>
                        }
                      </mat-menu>
                    } @else {
                      <!-- Country WITHOUT regions -->
                      <button
                        mat-menu-item
                        class="lib-select-item"
                        (click)="selectCountryFromDropdown(country)"
                      >
                        <span class="ellipsis p-2 px-3 d-block opacity-dark-9 text-primary font-size-small item" [class.font-weight-bold]="selectedCountry()?._id === country._id">
                          {{ country.name }}
                        </span>
                      </button>
                    }
                  }
                </mat-menu>

              </div>
            </div>
          </div>
        }
        @if (filteredSites()?.length && navigationService.moduleIdSig() !== 'reports') {
          <div
            class="custom-border cursor-pointer nav-item text-primary d-flex justify-content-between mr-2"
            [ngClass]="{ 'selected-item': isLevelSelected('site') }"
            (click)="navigateToSiteLevel()"
            (keydown)="navigateToSiteLevel()"
            role="button"
            tabindex="0"
          >
            <div class="d-flex align-items-center nav-item-name">
              <div class="pl-0 pr-1 d-flex align-items-center">
                <img [src]="'site-navigation' | iconsPipe: isLevelSelected('site') | async" alt="icon" />
              </div>
              <div class="d-flex nav-name flex-column">
                <div
                  class="font-weight-bold m-0 labels"
                  #siteNameLabel
                  [matTooltip]="selectedSite()?.name || ''"
                  [matTooltipDisabled]="!isTextOverflowing(siteNameLabel)"
                >
                  {{ selectedSite()?.name }}
                </div>
                <div class="font-size-small">Site ({{ sitesOptions()?.length }})</div>
              </div>
            </div>
            <div class="d-flex align-items-center nav-item-actions">
              <div
                class="ml-2 border rounded"
                [ngClass]="{
                  'selected-item action-button': shown.site,
                  'button-enabled': sitesOptions()?.length > 1,
                  'cursor-default': sitesOptions()?.length <= 1,
                }"
              >
                <lib-select
                  class="navigation"
                  [options]="sitesOptions()"
                  [label]="selectedSite()?.name"
                  [classes]="'font-size-normal text-primary h-100 mr-2'"
                  [itemClasses]="'text-primary font-size-very-small item'"
                  [disabled]="sitesOptions()?.length <= 1"
                  [notBold]="true"
                  [showCaret]="true"
                  [fullWidth]="true"
                  [placement]="'bottom-right'"
                  [container]="''"
                  [doNotTranslate]="true"
                  [enableSearch]="true"
                  (selectedChanged)="selectSites($event)"
                  (click)="$event.stopPropagation()"
                  [matTooltip]="sitesOptions()?.length <= 1 ? 'Only 1 site available' : null"
                />
              </div>
            </div>
          </div>
        }
        @if (this.selectedSite()?.Devices?.length && navigationService.moduleIdSig() !== 'reports') {
          <div
            class="custom-border cursor-pointer nav-item text-primary d-flex justify-content-between"
            [ngClass]="{ 'selected-item': isLevelSelected('device') }"
            (click)="navigateToDeviceLevel()"
            (keydown)="navigateToDeviceLevel()"
            role="button"
            tabindex="0"
          >
            <div class="d-flex align-items-center nav-item-name">
              <div class="pl-0 pr-1 d-flex align-items-center">
                <img
                  [src]="
                    deviceTypesList()?.[selectedDevice()?._id_deviceType] | iconsPipe: isLevelSelected('device') | async
                  "
                  alt="icon"
                />
              </div>
              <div class="d-flex nav-name flex-column">
                <div
                  #deviceNameLabel
                  class="font-weight-bold m-0 labels"
                  [matTooltip]="selectedDevice()?.displayName || ''"
                  [matTooltipDisabled]="!isTextOverflowing(deviceNameLabel)"
                >
                  {{ selectedDevice()?.displayName }}
                </div>
                <div class="font-size-small">
                  Device ({{ selectedDeviceIndex() + 1 }} of {{ devicesOptions()?.length }})
                </div>
              </div>
              @if (isLevelSelected('device')) {
                <div class="justify-content-end row" style="gap: 4px">
                  <div class="align-vertical-center">
                    <ng-template
                      [ngTemplateOutlet]="arrowButton"
                      [ngTemplateOutletContext]="{ forwards: false, disabled: !hasPrevTurbine() }"
                    ></ng-template>
                  </div>
                  <div class="align-vertical-center">
                    <ng-template
                      [ngTemplateOutlet]="arrowButton"
                      [ngTemplateOutletContext]="{ forwards: true, disabled: !hasNextTurbine() }"
                    ></ng-template>
                  </div>
                </div>
              }
            </div>
            <div class="d-flex align-items-center nav-item-actions">
              <div
                class="ml-2 border rounded"
                [ngClass]="{
                  'selected-item action-button': shown.device,
                  'button-enabled': devicesOptions()?.length > 1,
                  'cursor-default': devicesOptions()?.length <= 1,
                }"
              >
                <lib-select
                  class="navigation"
                  [options]="devicesOptions()"
                  [label]="selectedDevice()?.displayName"
                  [classes]="'font-size-normal text-primary h-100 mr-2'"
                  [itemClasses]="'text-primary font-size-very-small item'"
                  [disabled]="devicesOptions()?.length <= 1"
                  [notBold]="true"
                  [showCaret]="true"
                  [fullWidth]="true"
                  [placement]="'bottom-right'"
                  [container]="''"
                  [doNotTranslate]="true"
                  [enableSearch]="true"
                  (selectedChanged)="selectDevice($event)"
                  (click)="$event.stopPropagation()"
                  [matTooltip]="devicesOptions()?.length <= 1 ? 'Only 1 device available' : null"
                />
              </div>
            </div>
          </div>
        }
      }
    </div>
    <div class="p-3 d-flex justify-content-end align-items-center">
      @if (!smallNav()) {
        <div class="d-flex align-items-center pr-2 mr-2">
          <lib-theme-switch></lib-theme-switch>
        </div>
      }
      <div>
        <app-user-box [smallNav]="smallNav()"></app-user-box>
      </div>
    </div>
  </div>
</div>

<ng-template #arrowButton let-forwards="forwards" let-disabled="disabled">
  <button
    class="btn p-0 arrow-button"
    (click)="goToNextTurbine(forwards)"
    [disabled]="disabled"
    [ngClass]="{ 'button-enabled': !disabled }"
  >
    <div class="h-100 d-flex align-items-center">
      <i
        class="fas {{
          forwards ? 'fa-chevron-right' : 'fa-chevron-left'
        }} text-primary mx-auto font-size-small icon-color"
        style="cursor: inherit"
      ></i>
    </div>
  </button>
</ng-template>
